export default __webpack_public_path__ + "static/media/1128040325511320.ab3b5761.jpg";